import { useEffect, useState } from 'react';

import AddAddressSection from './AddAddressSection';
import Address from './Address';
import Link from 'next/link';
import { PATH } from 'Lib/constants/path';
import { getShippingAddress } from 'functions';

export default function ShippingAddress() {
  const [shippingAddress, setShippingAddress] = useState();

  useEffect(() => {
    if (shippingAddress == undefined) {
      setShippingAddress(getShippingAddress);
    }
  }, [shippingAddress]);

  return shippingAddress == null ? (
    <AddAddressSection />
  ) : (
    <div className="shipping-address cart-section-item">
      {shippingAddress && <Address addressData={shippingAddress} />}
      <Link href={PATH.ADDRESS_LIST}>
        <a className="text-blue-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </a>
      </Link>
    </div>
  );
}
